import styled from "styled-components/macro";

import { ReactComponent as ArrowIcon } from "../../assets/icons/icon_arrow.svg";

export const CardWrapper = styled.div<{ $isReviewsPage?: boolean }>`
  height: 624px;
  max-width: 424px; // TODO test width
  width: 100%; // TODO test width
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 50px;
  background: #fff;
  border-radius: 24px;
  border: 1px solid #B4B4B4;
  cursor: pointer;
  transition: 0.2s;
    
  &:hover {
     border-color: #141414;
     transition: 0.2s;
  }

  @media (max-width: 979px) {
    padding: 30px;
    height: ${({ $isReviewsPage }) => ($isReviewsPage ? "auto" : "540px")};
  }
`;

export const Tag = styled.div`
  font-weight: 500;
  background: #BFDCF5;
  width: fit-content;
  color: #141414;
  font-size: 16px;
  padding: 8px 16px;
  border-radius: 22px;
  display: inline-block;
  margin-bottom: 32px;

  @media (max-width: 979px) {
    font-size: 14px;
  }
`;

export const Title = styled.h3`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 35px;
  line-height: 86%;
  margin-bottom: 22px;

  @media (max-width: 979px) {
    font-size: 30px;
  }   
    
`;

export const Text = styled.p`
  font-size: 18px;
  margin-bottom: 16px;

  @media (max-width: 979px) {
    font-size: 15px;
  }
`;

export const Author = styled.p`
  display: flex;
  align-items: center;
  margin-top: auto;
`;

export const Name = styled.span`
  font-size: 18px;
  color: #A7A7A7;
  font-weight: 400;
  line-height: 25px;

  @media (max-width: 979px) {
    font-size: 15px;
  }
`

export const Job = styled.span`
  font-size: 18px;
  font-weight: 400;

  @media (max-width: 979px) {
    font-size: 15px;
  }
`

export const ProfileLink = styled.a`
  font-size: 18px;
  color: #55749F;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 28px;
  margin-top: 8px;

  @media (max-width: 979px) {
    font-size: 18px;
    line-height: 18px;
    margin-top: 13px;
  }
`;

export const Icon = styled(ArrowIcon)`
  width: 24px;
  height: 24px;
  
  path {
    fill: #55749F;
  }

  @media (max-width: 979px) {
    width: 22px;
    height: 12px;
  }
`
